<template>
  <Service color="green">
    <template v-slot:message>
      Du har blitt logget ut
    </template>
    <template v-slot:text>
      <a href="#" @click.prevent="login">Logg inn igjen</a>
    </template>
  </Service>
</template>

<script>
import Service from './Service'
export default {
  methods: {
    login () {
      this.$router.push({ name: 'BookStart', params: { id: this.$route.query.i } })
    }
  },
  components: {
    Service
  }
}
</script>

<style>

</style>
